import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UsedCommandType } from '~/constants/commands'

interface GalleryScreenState {
  activeExamplePopover: UsedCommandType | null
  activeNonFormPopover: UsedCommandType | null
}

const initialState: GalleryScreenState = {
  activeExamplePopover: null,
  activeNonFormPopover: null
}

const galleryScreenSlice = createSlice({
  name: 'galleryScreen',
  initialState,
  reducers: {
    setActiveExamplePopover(state, action: PayloadAction<UsedCommandType | null>) {
      state.activeExamplePopover = action.payload
    },
    hideExamplePopover(state) {
      state.activeExamplePopover = null
    },
    setActiveNonFormPopover(state, action: PayloadAction<UsedCommandType | null>) {
      state.activeNonFormPopover = action.payload
    },
    hideNonFormPopover(state) {
      state.activeNonFormPopover = null
    }
  }
})

export const {
  setActiveExamplePopover,
  hideExamplePopover,
  setActiveNonFormPopover,
  hideNonFormPopover
} = galleryScreenSlice.actions
export default galleryScreenSlice.reducer
